<template>
  <v-col class="col-md-3 col-sm-6 col-12">
    <v-card>
      <div class="member-figure" :style="aspectStyle">
        <picture>
          <source :srcset="webpSrcSet" type="image/webp" />
          <source :srcset="jpegSrcSet" type="image/jpeg" />
          <img :src="originalSrc" :alt="name" loading="lazy" class="member-img" />
        </picture>
        <div class="member-caption">
          <h2>{{ name }}</h2>
        </div>
      </div>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: 'Member',
  props: {
    name: String,
    picture: String,
    portrait: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    aspectStyle() {
      // Force a taller (portrait) card so tiles appear full-height vertically
      return { aspectRatio: '3 / 4' };
    },
    baseParts() {
      if (!this.picture) return { dir: '', base: '' };
      const parts = this.picture.split('/');
      const filename = parts.pop();
      const dir = parts.join('/');
      const idx = filename.lastIndexOf('.');
      const basename = idx !== -1 ? filename.slice(0, idx) : filename;
      const sanitize = (s) => s.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_.-]/g, '');
      return { dir, base: sanitize(basename) };
    },
    webpSrcSet() {
      const { dir, base } = this.baseParts;
      const prefix = dir ? `/members/thumbs/${dir}/` : '/members/thumbs/';
      return `${prefix
        + base}-320.webp 320w, ${prefix}${base}-640.webp 640w, ${prefix}${base}-1280.webp 1280w`;
    },
    jpegSrcSet() {
      const { dir, base } = this.baseParts;
      const prefix = dir ? `/members/thumbs/${dir}/` : '/members/thumbs/';
      return `${prefix
        + base}-320.jpg 320w, ${prefix}${base}-640.jpg 640w, ${prefix}${base}-1280.jpg 1280w`;
    },
    originalSrc() {
      const { dir, base } = this.baseParts;
      const prefix = dir ? `/members/thumbs/${dir}/` : '/members/thumbs/';
      return `${prefix + base}-640.jpg`;
    },
  },
};
</script>

<style scoped>
.member-figure {
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #222;
  display: block;
}
.member-figure img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: 50% 40%;
}
.member-caption {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 12px 16px;
  color: white;
}
.member-caption h2 {
  margin: 0;
  font-size: 1.6rem;
  font-weight: 400;
  letter-spacing: 0.5px;
}
</style>
